import React, { createRef } from "react";
import "./review.scss";
import FormTitle from "../components/formTitle/FormTitle";
import Config from "../common/Config";
import axios from "axios";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";
import Review from "./Review";
import { ClipLoader } from "react-spinners";

class PatientReview extends Review {
  constructor(props) {
    super(props);
    // this.pdfRef = createRef();
    this.targetRef = createRef();

    this.patientInfo1UomMetric = 1;
    this.patientInfo1UomImperial = 2;
    this.noFoamCarvingId = 513;
    this.nomodificationId = 154;

    this.customerSuppliedLockId = 43;
    this.customerSuppliedPlateId = 50;
    this.customerSuppliedValveId = 58;

    this.state = {
      isLoaded: false,
      accountNumber: null,
      clinicName: null,
      prosthetistName: null,
      email: null,
      poNumber: null,
      shippingAddress1: null,
      shippingAddress2: null,
      city: null,
      stateName: null,
      zip: null,
      phone: null,
      contactMethodName: null,
      shippingCarrierName: null,
      shippingMethodName: null,
      patientName: null,
      patientId: null,
      patientInfo1UOM: null,
      patientInfo1UOMName: null,
      height: null,
      weight: null,
      isBilateral: null,
      amputationLevel: null,
      kLevel: null,
      footDirection: null,
      footSize: null,
      estimatedShipDate: null,
      itemsSentIn: null,
      uOM: null,
      mPTToFloor: null,
      pmlWidth: null,
      residualLength: null,
      aboveMPT15cm: null,
      aboveMPT10cm: null,
      aboveMPT5cm: null,
      aboveMPT0cm: null,
      belowMPT5cm: null,
      belowMPT10cm: null,
      belowMPT15cm: null,
      belowMPT20cm: null,
      pml: null,
      ml: null,
      ap: null,
      iTToFloor: null,
      kCToFloor: null,
      tight5cm: null,
      tight10cm: null,
      tight15cm: null,
      tight20cm: null,
      tight25cm: null,
      tight30cm: null,
      loose5cm: null,
      loose10cm: null,
      loose15cm: null,
      loose20cm: null,
      loose25cm: null,
      loose30cm: null,
      limbLength: null,
      femurLength: null,
      flexion: null,
      adduction: null,
      castShippedSeparately: null,
      linerUsed: null,
      shapeCreationNotes: null,
      modification: [],
      modificationPercentage: [],
      modificationPly: [],
      trimline: [],
      brim: [],
      brimOther: [],
      shapeCreation: [],
      lock: [],
      lockType: [],
      valve: [],
      mountingPlate: [],
      material: [],
      foamCarving: [],
      insertMaterial: [],
      AKLynValveOption: [],
      linerInterface: null,
      linerSize: null,
      linerProfile: null,
      linerPartNumber: null,
      linerOptionCombinations: [],
      footType: null,
      footMaterial: null,
      footImpact: null,
      footPartNumber: null,
      includeFoot: null,
      footShell: null,
      includeLiner: null,
      linerQuantity: null,
      cart: [],
      cadFileName: null,
      customerSuppliedPlate: null,
      customerSuppliedLock: null,
      customerSuppliedValve: null,
    };
  }

  componentDidMount() {
    this.loadData();
    this.loadData2();
  }

  async loadData() {
    try {
      super.loadData();

      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
      };

      if (this.props.uniqueId != null) {
        config.headers.UniqueId = this.props.uniqueId;
      }

      let clinicInfoData = (
        await axios.get(
          Config.baseApiUrl + "clinicInfos/" + this.props.formTypeId,
          config
        )
      ).data;
      let notes = (
        await axios.get(
          Config.baseApiUrl + "notes/" + this.props.formTypeId,
          config
        )
      ).data;

      let footPartNumber = (
        await axios.get(
          Config.baseApiUrl + "footPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      let linerPartNumber = (
        await axios.get(
          Config.baseApiUrl + "linerPartNumber/" + this.props.formTypeId,
          config
        )
      ).data;

      let estimatedShipDate = (
        await axios.get(
          Config.baseApiUrl + "shipDate/" + this.props.formTypeId,
          config
        ) 
      ).data;

      const cadFile = (
        await axios.get(
          Config.baseApiUrl + "cadFiles/" + this.props.formTypeId,
          config
        )
      ).data;

      let patientInfo1Config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: ["patientInfo1UOM", "height", "weight"],
        },
      };

      if (this.props.uniqueId != null) {
        patientInfo1Config.headers.UniqueId = this.props.uniqueId;
      }

      let patientInfo1Data = (
        await axios.get(
          Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId,
          patientInfo1Config
        )
      ).data;

      let fieldInputConfig = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: [
            "amputationLevel",
            "kLevel",
            "footDirection",
            "footSize",
            "itemsSentIn",
            "uOM",
            "mPTToFloor",
            "pmlWidth",
            "residualLength",
            "aboveMPT15cm",
            "aboveMPT10cm",
            "aboveMPT5cm",
            "aboveMPT0cm",
            "belowMPT5cm",
            "belowMPT10cm",
            "belowMPT15cm",
            "belowMPT20cm",
            "pml",
            "ml",
            "ap",
            "iTToFloor",
            "kCToFloor",
            "tight5cm",
            "tight10cm",
            "tight15cm",
            "tight20cm",
            "tight25cm",
            "tight30cm",
            "loose5cm",
            "loose10cm",
            "loose15cm",
            "loose20cm",
            "loose25cm",
            "loose30cm",
            "limbLength",
            "femurLength",
            "flexion",
            "adduction",
            "castShippedSeparately",
            "modification",
            "modificationPercentage",
            "modificationPly",
            "trimline",
            "brim",
            "brimOther",
            "shapeCreation",
            "lock",
            "lockType",
            "valve",
            "mountingPlate",
            "material",
            "linerUsed",
            "notes",
            "foamCarving",
            "insertMaterial",
            "AKLynValveOption",
            "poNumber",
            "linerInterface",
            "linerSize",
            "linerProfile",
            "footType",
            "footMaterial",
            "footImpact",
            "includeFoot",
            "includeLiner",
            "linerQuantity",
            "footShell",
            "customerSuppliedPlate",
            "customerSuppliedLock",
            "customerSuppliedValve",
          ],
        },
      };

      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await axios.get(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;
        
      const customerSuppliedPlate = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedPlate")?.stringData;
      const customerSuppliedLock = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedLock")?.stringData;
      const customerSuppliedValve = fieldInputs.find((fi) => fi.fieldName === "customerSuppliedValve")?.stringData;

      this.setState({
        poNumber: clinicInfoData.poNumber,
        patientName: patientInfo1Data.patientName,
        patientId: patientInfo1Data.patientId,
        accountNumber: clinicInfoData.accountNumber,
        clinicName: clinicInfoData.clinicName,
        prosthetistName: clinicInfoData.prosthetistName,
        email: clinicInfoData.email,
        shippingAddress1: clinicInfoData.shippingAddress1,
        shippingAddress2: clinicInfoData.shippingAddress2,
        city: clinicInfoData.city,
        stateName: clinicInfoData.stateName,
        zip: clinicInfoData.zip,
        phone: this.formatPhone(clinicInfoData.phone),
        contactMethodName: clinicInfoData.contactMethodName,
        shippingCarrierName: clinicInfoData.shippingCarrierName,
        shippingMethodName: clinicInfoData.shippingMethodName,
        isBilateral: this.getYesNo(patientInfo1Data.isBilateral),
        notes: notes.data,
        estimatedShipDate: estimatedShipDate,
        patientInfo1UOM: patientInfo1Data.fieldInputs.find(
          (fi) => fi.fieldName === "patientInfo1UOM"
        ).fieldOptionId,
        patientInfo1UOMName: patientInfo1Data.fieldInputs.find(
          (fi) => fi.fieldName === "patientInfo1UOM"
        ).fieldOptionName,
        amputationLevel: fieldInputs.find(
          (fi) => fi.fieldName === "amputationLevel"
        ).fieldOptionName,
        kLevel: fieldInputs.find((fi) => fi.fieldName === "kLevel")
          .fieldOptionName,
        footDirection: fieldInputs.find(
          (fi) => fi.fieldName === "footDirection"
        ).fieldOptionName,
        footSize: this.getFootSizeText(
          fieldInputs.find((fi) => fi.fieldName === "footSize").numericData
        ),
        itemsSentIn: fieldInputs.find((fi) => fi.fieldName === "itemsSentIn")
          .stringData,
        linerSize: fieldInputs.find((fi) => fi.fieldName === "linerSize")?.fieldOptionName,
        linerProfile: fieldInputs.find((fi) => fi.fieldName === "linerProfile")?.fieldOptionName,
        linerInterface: fieldInputs.find((fi) => fi.fieldName === "linerInterface")?.fieldOptionName,
        linerPartNumber: linerPartNumber,
        footPartNumber: footPartNumber,
        footShell: fieldInputs.find((fi) => fi.fieldName === "footShell")?.fieldOptionName,
        footType: fieldInputs.find((fi) => fi.fieldName === "footType")?.fieldOptionName,
        footMaterial: fieldInputs.find((fi) => fi.fieldName === "footMaterial")?.fieldOptionName,
        footImpact: fieldInputs.find((fi) => fi.fieldName === "footImpact")?.fieldOptionName,
        linerQuantity:
        fieldInputs.find((fi) => fi.fieldName === "linerQuantity")?.numericData ??
        0,
        includeLiner: fieldInputs.find((fi) => fi.fieldName === "includeLiner")?.fieldOptionName === "Yes",
        includeFoot: fieldInputs.find((fi) => fi.fieldName === "includeFoot")?.fieldOptionName === "Yes",
        
        customerSuppliedPlate: (customerSuppliedPlate === "" || customerSuppliedPlate === null) ? "No Value Entered" : customerSuppliedPlate,
        customerSuppliedLock: (customerSuppliedLock === "" || customerSuppliedPlate === null) ? "No Value Entered" : customerSuppliedLock,
        customerSuppliedValve: (customerSuppliedValve === "" || customerSuppliedPlate === null) ? "No Value Entered" : customerSuppliedValve,
        cadFileName: cadFile !== null && cadFile.isActive ? cadFile.cadFileName : null,
      });
      this.setState({
        height: this.getHeightText(
          patientInfo1Data.fieldInputs.find((fi) => fi.fieldName === "height")
            .numericData
        ),
        weight: this.getWeightText(
          patientInfo1Data.fieldInputs.find((fi) => fi.fieldName === "weight")
            .numericData
        ),
      });
      await this.loadCart(config);
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }
  async loadData2() {
    try {
      super.loadData();
      let fieldInputConfig = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: [
            "uOM",
            "mPTToFloor",
            "pmlWidth",
            "residualLength",
            "aboveMPT15cm",
            "aboveMPT10cm",
            "aboveMPT5cm",
            "aboveMPT0cm",
            "belowMPT5cm",
            "belowMPT10cm",
            "belowMPT15cm",
            "belowMPT20cm",
            "pml",
            "ml",
            "ap",
            "iTToFloor",
            "kCToFloor",
            "tight5cm",
            "tight10cm",
            "tight15cm",
            "tight20cm",
            "tight25cm",
            "tight30cm",
            "loose5cm",
            "loose10cm",
            "loose15cm",
            "loose20cm",
            "loose25cm",
            "loose30cm",
            "limbLength",
            "femurLength",
            "flexion",
            "adduction",
            "castShippedSeparately",
            "modification",
            "modificationPercentage",
            "modificationPly",
            "trimline",
            "brim",
            "brimOther",
            "shapeCreation",
            "lock",
            "lockType",
            "valve",
            "mountingPlate",
            "material",
            "linerUsed",
            "notes",
            "foamCarving",
            "insertMaterial",
            "AKLynValveOption",            
          ],
        },
      };

      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await axios.get(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;
      let newState = this.state;

      newState["uOM"] = fieldInputs.find(
        (fi) => fi.fieldName === "uOM"
      ).fieldOptionName;
      this.setNumericProperty(newState, fieldInputs, "mPTToFloor");
      this.setNumericProperty(newState, fieldInputs, "pmlWidth");
      this.setNumericProperty(newState, fieldInputs, "residualLength");
      this.setNumericProperty(newState, fieldInputs, "aboveMPT15cm");
      this.setNumericProperty(newState, fieldInputs, "aboveMPT10cm");
      this.setNumericProperty(newState, fieldInputs, "aboveMPT5cm");
      this.setNumericProperty(newState, fieldInputs, "aboveMPT0cm");
      this.setNumericProperty(newState, fieldInputs, "belowMPT5cm");
      this.setNumericProperty(newState, fieldInputs, "belowMPT10cm");
      this.setNumericProperty(newState, fieldInputs, "belowMPT15cm");
      this.setNumericProperty(newState, fieldInputs, "belowMPT20cm");
      this.setNumericProperty(newState, fieldInputs, "pml");
      this.setNumericProperty(newState, fieldInputs, "ml");
      this.setNumericProperty(newState, fieldInputs, "ap");
      this.setNumericProperty(newState, fieldInputs, "iTToFloor");
      this.setNumericProperty(newState, fieldInputs, "kCToFloor");
      this.setNumericProperty(newState, fieldInputs, "tight5cm");
      this.setNumericProperty(newState, fieldInputs, "tight10cm");
      this.setNumericProperty(newState, fieldInputs, "tight15cm");
      this.setNumericProperty(newState, fieldInputs, "tight20cm");
      this.setNumericProperty(newState, fieldInputs, "tight25cm");
      this.setNumericProperty(newState, fieldInputs, "tight30cm");
      this.setNumericProperty(newState, fieldInputs, "loose5cm");
      this.setNumericProperty(newState, fieldInputs, "loose10cm");
      this.setNumericProperty(newState, fieldInputs, "loose15cm");
      this.setNumericProperty(newState, fieldInputs, "loose20cm");
      this.setNumericProperty(newState, fieldInputs, "loose25cm");
      this.setNumericProperty(newState, fieldInputs, "loose30cm");
      this.setNumericProperty(newState, fieldInputs, "limbLength");
      this.setNumericProperty(newState, fieldInputs, "femurLength");
      this.setNumericProperty(newState, fieldInputs, "flexion");
      this.setNumericProperty(newState, fieldInputs, "adduction");
      this.setBooleanProperty(newState, fieldInputs, "castShippedSeparately");
      this.setStringProperty(newState, fieldInputs, "linerUsed");
      newState.shapeCreationNotes = fieldInputs.find(
        (fi) => fi.fieldName === "notes"
      ).stringData;

      this.setArrayProperty(newState, fieldInputs, "modification");
      this.setArrayProperty(newState, fieldInputs, "modificationPercentage");
      this.setArrayProperty(newState, fieldInputs, "modificationPly");
      this.setArrayProperty(newState, fieldInputs, "trimline");
      this.setArrayProperty(newState, fieldInputs, "brim");
      this.setArrayProperty(newState, fieldInputs, "brimOther");
      this.setArrayProperty(newState, fieldInputs, "shapeCreation");
      this.setArrayProperty(newState, fieldInputs, "foamCarving");
      this.setArrayProperty(newState, fieldInputs, "lock");
      this.setArrayProperty(newState, fieldInputs, "lockType");
      this.setArrayProperty(newState, fieldInputs, "valve");
      this.setArrayProperty(newState, fieldInputs, "insertMaterial");
      this.setArrayProperty(newState, fieldInputs, "mountingPlate");
      this.setArrayProperty(newState, fieldInputs, "material");
      this.setArrayProperty(newState, fieldInputs, "AKLynValveOption");

      this.setState(newState);
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
  }
  async saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    return axios.post(
      Config.baseApiUrl + "orders/" + this.props.formTypeId,
      null,
      config
    );
  }

  formatPhone(phone) {
    if (phone !== null && phone.length === 12) {
      return (
        "(" +
        phone.substr(2, 3) +
        ") " +
        phone.substr(5, 3) +
        "-" +
        phone.substr(8, 4)
      );
    }

    return phone;
  }

  getHeightText(height) {
    if (this.state.patientInfo1UOM === this.patientInfo1UomMetric) {
      return height + " cm";
    } else {
      return Math.floor(height / 12) + "' " + (height % 12) + '"';
    }
  }

  getWeightText(weight) {
    if (this.state.patientInfo1UOM === this.patientInfo1UomMetric) {
      return weight + " kg";
    } else {
      return weight + " lbs";
    }
  }

  getFootSizeText(footSize) {
    return footSize + " cm";
  }

  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  setNumericProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] =
      fieldInputs.find((fi) => fi.fieldName === propertyName)?.numericData ?? 0;
  }

  setStringProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = fieldInputs.find(
      (fi) => fi.fieldName === propertyName
    )?.stringData;
  }

  setBooleanProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = this.getYesNo(
      fieldInputs.find((fi) => fi.fieldName === propertyName)?.booleanData
    );
  }

  setArrayProperty(obj, fieldInputs, propertyName) {
    obj[propertyName] = fieldInputs.filter(
      (fi) => fi.fieldName === propertyName
    );
  }

  getFlexionLabel() {
    return this.state.flexion >= 0 ? "Flexion" : "Extension";
  }
  getAdductionLabel() {
    return this.state.adduction >= 0 ? "Adduction" : "Abduction";
  }

  getNavButtons(uniqueId) {
    if (uniqueId != null) {
      return;
    }

    return (
      <div className="handelButtons">
            <div className="stepBtn">
              <SecondaryButton
                text="Back"
                onClick={() =>
                  this.props.handleBack(this?.props?.currentIndex - 1)
                }
                disabled={
                  this.props.activeOuterStep == 0 && this.props.innerStep == 0
                }
              />
              <Button
                text="Submit"
                disabled={this.state.isLoading}
                onClick={() => {
                  this.saveData();
                  this.props.handleNext(this?.props?.currentIndex);
                }}
              />
            </div>
          </div>
    );
  }

  async loadCart(config) {
    if (this.props.uniqueId != null) {
      config.headers.UniqueId = this.props.uniqueId;
    }

    let orderCart = (await axios.get(
      Config.baseApiUrl + "cart/" + this.props.formTypeId,
      config
    )).data;

    this.setState({ cart: orderCart });
  }

  cartTotal(cart) {
    let total = 0;
    cart.forEach((item) => {
      if (item.quantity > 0 && item.price > 0) {
        total += item.price * item.quantity;
      }
    });

    return total;
  }

  formatPrice(price) {
    return Number(price).toFixed(2);
  }

  render() {
    if (!this.state.isLoaded) {
      return (
        <div className="loader">
          <ClipLoader color="#000000" size={40} />
        </div>
      );
    } else {
      return (
        <>
          <div
            className={`reviewWrapper ${
              this.props.isBilateral ? "bilateralWrapper" : ""
            }`}
          >
            {!this.props.isBilateral && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <FormTitle
                  title="Order Review"
                  description=""
                />
                {/* <button onClick={this.downloadPdf}>Download as pdf</button> */}
              </div>
            )}

            <div className="reviews" ref={this.targetRef}>
              <div>
                {!this.props.showOrderSummary && (
                  <div className="summaryName">
                    <h4>Order Summary</h4>
                    {this.props.isBilateral && (
                      <div className="bileralName">
                        <h2>{this.props.bilateralName}</h2>
                      </div>
                    )}
                    {!this.props.isBilateral && <h2>{this.props.formName}</h2>}
                  </div>
                )}
                <div className="summaaryHeader">
                  <h2>
                    {this.props.name}
                    {this.props.isBilateral &&
                      " (Order " + this.props.orderNumber + ")"}
                  </h2>
                  <div className="poDate">
                    <div className="po">
                      <span>PO:</span>
                      <p>{this.state.poNumber}</p>
                    </div>
                    <div className="po">
                      <span>SSD:</span>
                      <p>{this.formatShipDate(this.state.estimatedShipDate)}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="information">
                <h3>Patient Information</h3>
                <div className="patientInfo">
                  <div className="infoBorder">
                    <div className="patientSubInfo">
                      <span>Patient ID:</span>
                      <p>{this.state.patientId}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Weight:</span>
                      <p>{this.state.weight}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Height:</span>
                      <p>{this.state.height}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Foot Size:</span>
                      <p>{this.state.footSize}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>K Level</span>
                      <p>{this.state.kLevel}</p>
                    </div>
                  </div>

                  <div className="info">
                    <div className="patientSubInfo">
                      <span>Amputation Level</span>
                      <p>{this.state.amputationLevel}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Amputation Side</span>
                      <p>{this.state.footDirection}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>PO#</span>
                      <p>{this.state.poNumber}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="information">
                <div className="subDetail">
                  <h3>Patient Measurement</h3>

                  <div className="detailWrapper">
                    {this.state.shapeCreation[0]?.fieldOptionName ===
                      "From Measurements" && (
                      <div className="detail">
                        <h4>Measurements</h4>
                        {this.props.formTypeId == 3 && (
                          <div className="detailContentWrapper">
                            <div className="borderBotom">
                              <div className="content">
                                <span>PML:</span>
                                <p>
                                  {this.formatMeasurement(this.state.pmlWidth)}
                                </p>
                              </div>
                              <div className="content">
                                <span>ML:</span>
                                <p> {this.formatMeasurement(this.state.ml)}</p>
                              </div>
                              <div className="content">
                                <span>AP:</span>
                                <p>{this.formatMeasurement(this.state.ap)}</p>
                              </div>
                              <div className="content">
                                <span>Limb Length:</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.limbLength
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span>MPT to Floor:</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.mPTToFloor
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="levelMesurement">
                              <div className="lm">
                                <span>Level</span>
                                <span>Measurement</span>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(15)}</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.aboveMPT15cm
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(10)}</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.aboveMPT10cm
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(5)}</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.aboveMPT5cm
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(0)}</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.aboveMPT0cm
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(5)}</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.belowMPT5cm
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(10)}</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.belowMPT10cm
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(15)}</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.belowMPT15cm
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(20)}</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.belowMPT20cm
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}

                        {this.props.formTypeId == 4 && (
                          
                          <div className="detailContentWrapper">
                            <div className="borderBotom">
                              <div className="content">
                                <span>Limb Length:</span>
                                <p>
                                  {this.formatMeasurement(
                                    this.state.limbLength
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span>Femur:</span>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(
                                    this.state.femurLength
                                  )}
                                </p>
                              </div>
                              <div className="content">
                                <span>KC to Floor:</span>
                                <p>
                                  {this.formatMeasurement(this.state.kCToFloor)}
                                </p>
                              </div>
                              <div className="content">
                                <span>IT to Floor:</span>
                                <p>
                                  {this.formatMeasurement(this.state.iTToFloor)}
                                </p>
                              </div>
                            </div>
                            <div className="levelMesurement">
                              <div className="lm">
                                <span>Level</span>
                                <span>Tight</span>
                                <span>Loose</span>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(5)}</span>
                                <p>
                                  {this.formatMeasurement(this.state.tight5cm)}
                                </p>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(this.state.loose5cm)}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(10)}</span>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(this.state.tight10cm)}
                                </p>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(this.state.loose10cm)}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(15)}</span>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(this.state.tight15cm)}
                                </p>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(this.state.loose15cm)}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(20)}</span>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(this.state.tight20cm)}
                                </p>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(this.state.loose20cm)}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(25)}</span>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(this.state.tight25cm)}
                                </p>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(this.state.loose25cm)}
                                </p>
                              </div>
                              <div className="content">
                                <span> {this.getIntervalFromCM(30)}</span>
                                <p>
                                  {" "}
                                  {this.formatMeasurement(this.state.tight30cm)}
                                </p>
                                <p>
                                  {this.formatMeasurement(this.state.loose30cm)}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    <div className="leftContent">
                      <div className="detail">
                        <h4>Shape Creation</h4>
                        <div className="detailContentWrapper">
                          <div className="content">
                            <span>Shape Creation:</span>
                            {this.makeFieldOutput(this.state.shapeCreation)}
                          </div>
                          {this.state.cadFileName !== null ? (
                            <div className="content">
                              <span>Filename:</span>
                              <p>{this.state.cadFileName}</p>
                            </div>
                          ) : <></>}
                          <div className="content">
                            <span>Liner Model:</span>
                            <p>{this.state.linerUsed}</p>
                          </div>
                        </div>
                      </div>

                      {this.props.formTypeId == 3 && (
                        <div className="detail">
                          <h4>Trimline</h4>
                          <div className="detailContentWrapper">
                            <div className="content">
                              <span>Trimline:</span>
                              {this.makeFieldOutput(this.state.trimline)}
                            </div>
                          </div>
                        </div>
                      )}

                      {this.props.formTypeId == 4 && this.state.brim.length > 0 && this.state.brim.some(opt => opt.fieldOptionName) && (
                        <div className="detail">
                          <h4>Brim</h4>
                          <div className="detailContentWrapper">
                            <div className="content">
                              <span>Brim:</span>
                              {this.makeFieldOutput(this.state.brim)}
                            </div>
                          </div>
                        </div>
                      )}
                      
                      <div className="detail">
                        <h4>Modification</h4>
                        <div className="detailContentWrapper">
                          <div className="content">
                            {this.state.modification.length > 0 &&
                              this.state.modification[0].fieldOptionId !==
                              this.nomodificationId ? (
                              <>
                                {this.makeConditionalModificationFieldOutput(
                                  "Percentage",
                                  this.state.modificationPercentage,
                                  "numericData"
                                )}
                                {this.makeConditionalModificationFieldOutput(
                                  "Ply",
                                  this.state.modificationPly,
                                  "numericData"
                                )}
                              </>) : <span>No Modification</span>}
                          </div>
                        </div>
                      </div>

                      <div className="detail">
                        <h4>Angles</h4>
                        <div className="detailContentWrapper">
                          <div className="content">
                            <span> {this.getFlexionLabel()}:</span>
                            <p>{Math.abs(this.state.flexion)}°</p>
                          </div>
                          <div className="content">
                            <span>{this.getAdductionLabel()}:</span>
                            <p>{Math.abs(this.state.adduction)}°</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="borderBotom">
                  <div className="msgInfo ">
                    <h3>Measurement Notes</h3>
                    <p>{this.state.shapeCreationNotes}</p>
                  </div>
                </div>

                <div className="subDetail">
                  <h3>Product Information</h3>
                  <div className="detailWrapper">
                    <div className="rightContent">

                      <div className="detail">
                        <h4>Socket Options</h4>
                        <div className="detailContentWrapper">
                          <div className="content">
                            <span>Foam Carving:</span>
                            {this.makeFieldOutput(this.state.foamCarving)}
                          </div>
                          <div className="content">
                            <span>Socket Material:</span>
                            {this.makeFieldOutput(this.state.material)}
                            <div>{/* <span>CS-TSTT-101</span> */}</div>
                          </div>
                        </div>
                      </div>

                      <div className="detail">
                        <h4>Suspension</h4>
                        <div className="detailContentWrapper">
                          <div className="content">
                            <span>Lock:</span>
                            <div>
                              {this.makeFieldOutput(this.state.lock)}
                            </div>
                          </div>
                          {this.state.lock && this.state.lock[0].fieldOptionId === this.customerSuppliedLockId ?
                          <div className="content">
                            <span>Lock Name:</span>
                            <p>
                              {this.state.customerSuppliedLock}
                            </p>
                          </div> : <></>}
                          <div className="content">
                            <span>Valve:</span>
                            <div>
                              {this.makeFieldOutput(this.state.valve)}
                              {/* <span>CS-TSAD-142</span> */}
                            </div>
                          </div>
                          {this.state.valve && this.state.valve[0].fieldOptionId === this.customerSuppliedValveId ?
                          <div className="content">
                            <span>Valve Name:</span>
                            <p>
                              {this.state.customerSuppliedValve}
                            </p>
                          </div> : <></>}
                        </div>
                      </div>
                    </div>

                    <div className="leftContent">

                      {
                        this.state.material[0].fieldOptionId
                          !== this.ThermolynId ? <div className="detail">
                          <h4>Mounting Plates</h4>
                          <div className="detailContentWrapper">
                            <div className="content">
                              <span>Material:</span>
                              <div>
                                  {this.makeFieldOutput(this.state.mountingPlate)}
                              </div>
                            </div>
                            {this.state.mountingPlate && this.state.mountingPlate[0].fieldOptionId === this.customerSuppliedPlateId ?
                              <div className="content">
                                <span>Material Name:</span>
                                <p>
                                  {this.state.customerSuppliedPlate}
                                </p>
                              </div> : <></>}
                          </div>
                        </div> : <></>}

                      <div className="detail">
                        <h4>Insert Material</h4>
                        <div className="detailContentWrapper">
                          <div className="content">
                            <span>Material:</span>
                            <div>
                                {this.isFieldOutputNull(this.makeFieldOutput(this.state.insertMaterial)) ===
                                  true ? this.noInsertSelected :
                                  this.makeFieldOutput(this.state.insertMaterial)}
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div className="msgInfo ">
                    <h3>Items sent in with socket</h3>
                    <p>{this.state.itemsSentIn}</p>
                  </div>

                  <div className="msgInfo ">
                    <h3>Other Notes</h3>
                    <p>{this.state.notes}</p>
                  </div>
                </div>
              </div>

              {this.state.includeLiner && this.state.linerQuantity > 0 &&  (
              <div className="information">
                <h3>Liner Selection</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Interface:</span>
                      <p>{this.state.linerInterface}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Profile:</span>
                      <p>{this.state.linerProfile}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Size:</span>
                      <p>{this.state.linerSize}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Part Number:</span>
                      <p>{this.state.linerPartNumber}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Quantity:</span>
                      <p>{this.state.linerQuantity}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {this.state.includeFoot && (
              <div className="information">
                <h3>Foot Selection</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Type:</span>
                      <p>{this.state.footType}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Material:</span>
                      <p>{this.state.footMaterial}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Impact Level:</span>
                      <p>{this.state.footImpact}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Foot Shell:</span>
                      <p>{this.state.footShell}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Part Number:</span>
                      <p>{this.state.footPartNumber}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}


              {!this.props.showOrderInfo && (
                <>
                  <div className="customerInformation">
                    <div className="information ">
                      <h3>Customer Informations</h3>
                      <div className="patientInfo">
                        <div className="customerInfo">
                          <div className="patientSubInfo">
                            <span>Bill to account:</span>
                            <p>{this.state.accountNumber}</p>
                          </div>
                          <div className="patientSubInfo">
                            <span>Clinic:</span>
                            <p>{this.state.clinicName}</p>
                          </div>
                          <div className="patientSubInfo">
                            <span>Clinician Name:</span>
                            <p>{this.state.prosthetistName}</p>
                          </div>
                          <div className="patientSubInfo">
                            <span>Email Address</span>
                            <p>{this.state.email}</p>
                          </div>
                          <div className="patientSubInfo">
                            <span>Phone</span>
                            <p>{this.state.phone}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="shippingInformation">
                    <div className="information">
                      <h3>Shipping Information</h3>
                      <div className="patientInfo">
                        <div className="">
                          <div className="borderBotom shippingInfo">
                            <div className="patientSubInfo">
                              <span>Shipping Address Line 1:</span>
                              <p>{this.state.shippingAddress1}</p>
                            </div>
                            <div className="patientSubInfo">
                              <span>Shipping Address Line 2:</span>
                              <p>{this.state.shippingAddress2}</p>
                            </div>
                          </div>

                          <div className="shipping info">
                            <div className="patientSubInfo">
                              <span>State:</span>
                              <p>{this.state.stateName}</p>
                              <span>City:</span>
                              <p>{this.state.city}</p>
                              <span>Shipping Method:</span>
                              <p>{this.state.shippingMethodName}</p>
                            </div>
                            <div className="patientSubInfo">
                              <span>Zip Code:</span>
                              <p>{this.state.zip}</p>
                              <span>Carrier:</span>
                              <p>{this.state.shippingCarrierName}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {this.state.cart.length > 0 ? (
                    <div className="information">
                      <div className="mb-3"><h3>Cart</h3></div>
                      <div className="patientInfo">
                        <div className="patientSubInfo">
                          <table className="transparent-table table">
                            <thead>
                              <tr>
                                <th><span><b>Name</b></span></th>
                                <th></th>
                                <th><span><b>Part Number</b></span></th>
                                <th><span><b>Quantity</b></span></th>
                                <th className="text-right"><span><b>Price</b></span></th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.cart.map(item => {
                                return (
                                  <tr key={item.partNumber}>
                                    <td lg="6" sm="1">
                                      <div className="content">
                                        <p style={{ "whiteSpace": "break-spaces" }}>{item.name}</p>
                                      </div>
                                    </td>
                                    <td></td>
                                    <td>
                                      <p>{item.partNumber}</p>
                                    </td>
                                    <td>
                                      <p>{item.quantity}</p>
                                    </td>
                                    <td>
                                      <p className="text-right">${this.formatPrice(item.price)}</p>
                                    </td>
                                  </tr>)
                              })}
                              <tr>
                                <td>
                                  <div>
                                    <span><b>Total</b></span>
                                  </div>
                                </td>
                                <td colSpan={4}>
                                  <p className="text-right">
                                    ${this.formatPrice(this.cartTotal(this.state.cart))}
                                  </p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  ) : <></>}


                </>
              )}
            </div>
          </div>
          {this.getNavButtons(this.props.uniqueId)}
        </>
      );
    }
  }

  getIntervalFromCM(cm) {
    if (this.state.uOM === "inches") {
      return `${cm / 2.5} in`;
    } else {
      return `${cm} cm`;
    }
  }
}

export default PatientReview;
